import { render } from "./ChildrenSingleSelectBox.vue?vue&type=template&id=cf6c0ea8&scoped=true"
import script from "./ChildrenSingleSelectBox.vue?vue&type=script&lang=js"
export * from "./ChildrenSingleSelectBox.vue?vue&type=script&lang=js"

import "./ChildrenSingleSelectBox.vue?vue&type=style&index=0&id=cf6c0ea8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6c0ea8"]])

export default __exports__